export default __webpack_public_path__ + "static/media/sphere@1x.383e0ae1.webp";